import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import arrow_right from '../../images/icons/arrow_right.svg';
import arrow_left from '../../images/icons/arrow_left.svg';

const ReadingsPagination = ({ currPageNo, totalPages, changePageNo }) => {
  const shouldBeDisplayed = totalPages > 1;
  const handlePageClick = data => {
    const selectedPage = data.selected + 1;
    changePageNo(selectedPage);
  };
  if (!shouldBeDisplayed) return null;
  return (
    <ReactPaginate
      pageCount={totalPages}
      pageRangeDisplayed={3}
      marginPagesDisplayed={1}
      initialPage={currPageNo - 1}
      disableInitialCallback={true}
      previousLabel={
        <>
          <img src={arrow_left} alt="Poprzednia strona" />
          <span>Poprzednia</span>
        </>
      }
      nextLabel={
        <>
          <span>Następna</span>
          <img src={arrow_right} alt="Poprzednia strona" />
        </>
      }
      breakLabel="..."
      breakClassName="reading-pagination-break"
      onPageChange={handlePageClick}
      containerClassName="pagination reading-pagination"
      pageClassName="reading-page-item"
      pageLinkClassName="reading-page-link"
      disabledClassName="navlink-disabled"
      previousClassName="navlink navlink-previous"
      nextClassName="navlink navlink-next"
      activeClassName="active"
    />
  );
};

ReadingsPagination.propTypes = {
  currPageNo: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  changePageNo: PropTypes.func.isRequired
};

export default ReadingsPagination;
